const META_NAME = "build-version";
const LOG_PREFIX = "🏷️ Build Version:";

const injectBuildVersionMeta = (version: string): void => {
  if (typeof document === "undefined") return;

  const existing = document.querySelector<HTMLMetaElement>(
    `meta[name="${META_NAME}"]`
  );
  if (existing) {
    existing.setAttribute("content", version);
    return;
  }

  const meta = document.createElement("meta");
  meta.setAttribute("name", META_NAME);
  meta.setAttribute("content", version);
  document.head.appendChild(meta);
};

const getBuildVersion = (): string =>
  process.env.NEXT_PUBLIC_BUILD_VERSION ||
  process.env.NEXT_PUBLIC_DD_DATE ||
  "local";

const exposeBuildVersion = (): string => {
  const version = getBuildVersion();
  injectBuildVersionMeta(version);
  // eslint-disable-next-line no-console
  console.info(`${LOG_PREFIX} ${version}`);
  return version;
};

export { exposeBuildVersion, getBuildVersion };
